import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-tab[label]',
    templateUrl: './tab.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TabComponent {

    @Input()
    public value: any

    @Input()
    public label: string = ''

    public active: boolean = false

}
